<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="ded">
<p class="center">For Ann Hughes,<br/> true friend, free spirit,<br/>and brave heart.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780061957710_epub_ded_r1.vue?38fbabfa